import CrudBase from '../../CrudBase';
import axios from '../../../axios-common';

class PerformanceApi extends CrudBase {
	getPerformance = (params) => axios.get(`${this.endpoint}/get-by`, params);

	defaultMethods = {
		...this.defaultMethods,
		getPerformance: this.getPerformance,
	};
}

const performance = new PerformanceApi('/api/v1/performance');

export default performance.defaultMethods;
